import { SVGProps } from "react";

export default function EthWallet(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width ? props.width : "24"}
      height={props.height ? props.height : "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
      className={props.className}
        d="M8.77011 14.4262L10.3801 15.1462C11.4101 15.6062 12.5901 15.6062 13.6301 15.1462L15.2401 14.4262C16.6801 13.7862 18.0101 15.5262 17.0101 16.7462L13.5501 20.9762C12.7001 22.0162 11.3101 22.0162 10.4501 20.9762L7.00011 16.7462C5.99011 15.5262 7.32011 13.7862 8.77011 14.4262Z"
        fill="white"
      />
      <path
      className={props.className}
        d="M8.57002 11.6719C8.27002 11.8919 8.31003 12.3519 8.65003 12.5219L11 13.6919C11.55 13.9719 12.44 13.9719 12.98 13.6919L15.33 12.5219C15.66 12.3519 15.7 11.9019 15.41 11.6719L12.3 9.33187C12.12 9.20188 11.88 9.20188 11.7 9.33187L8.57002 11.6719Z"
        fill="white"
      />
      <path
      className={props.className}
        d="M17.8801 8.24118L13.7101 3.04118C13.6301 2.94118 13.5401 2.85118 13.4501 2.76118C13.1901 2.51118 12.8201 2.74118 12.8201 3.10118V7.40118C12.8201 7.56118 12.8901 7.71118 13.0201 7.80118L17.1701 10.9212L17.3501 11.0512C17.5301 11.1812 17.7801 11.1812 17.9301 11.0212C18.6301 10.2612 18.6201 9.16118 17.8801 8.24118Z"
        fill="white"
      />
      <path
      className={props.className}
        d="M6.1101 8.33082L10.2601 3.05082C10.3401 2.95082 10.4201 2.86082 10.5101 2.77082C10.7701 2.52082 11.1401 2.74082 11.1401 3.11082V7.48082C11.1401 7.64082 11.0701 7.78082 10.9401 7.88082L6.8101 11.0508L6.6401 11.1808C6.4601 11.3108 6.2101 11.3108 6.0501 11.1408C5.3701 10.3708 5.3801 9.27082 6.1101 8.33082Z"
        fill="white"
      />
    </svg>
  );
}
